import React from 'react';

export const name = 'chevron';
export const Chevron = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1899 19.9988L7.80994 12.0188L16.1899 4.00128"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
